/**
 * Raised when an error happens when trying make an API call.
 */
export class BaseApiError extends Error {}
